module.exports = __webpack_public_path__ + "static/media/user.cf73aa64.svg";